export const SliderData = [
  {
    image: require('./images/slide1.png'),
    header: 'Header 1',
    txt: 'This is the text for slide1'
  },
  {
    image: require('./images/slide2.jpg'),
    header: 'Header 2',
    txt: 'This is the text for slide2'
  },
  {
    image: require('./images/slide3.jpg'),
    header: 'Header 3',
    txt: 'This is the text for slide3'
  },
];